// Gets loaded on every vue page (on page load)

import { createApp } from "vue";
import { createPinia } from "pinia";
import { i18n } from "./app/translations";
import debounce from "./app/helpers/debounce";
import { createVfm } from "vue-final-modal";

import Home from "./app/Home.vue";
import Search from "./app/Search.vue";
import Category from "./app/Category.vue";
import Person from "./app/Person.vue";
import Location from "./app/Location.vue";
import Timespan from "./app/Timespan.vue";

const pinia = createPinia();
const vfm = createVfm();

function setupApp(AppComponent, appId) {
  const root = document.querySelector(`#app-${appId}`);
  if (!root) return;

  // Extract data-vue-* attributes as props
  const props = Object.fromEntries(
    Array.from(root.attributes)
      .filter((attr) => attr.name.startsWith("data-vue-"))
      .map((attr) => [attr.name.replace(/^data-vue-/, ""), attr.value])
  );

  const app = createApp(AppComponent, props);

  app.use(pinia);
  app.use(i18n);
  app.use(vfm);
  app.directive("debounce", (el, binding) => debounce(el, binding));

  app.mount(root);

  // Once Vue has taken over, hide the SSR-rendered article list to avoid duplicates.
  // The SSR list exists for first-paint and crawler discoverability only.
  document.querySelectorAll("[data-ssr-article-list]").forEach((el) => {
    el.style.display = "none";
  });
}

setupApp(Home, "home");
setupApp(Search, "search");
setupApp(Category, "article-category");
setupApp(Location, "article-location");
setupApp(Person, "article-person");
setupApp(Timespan, "article-timespan");
